// Layout of this screen is a bit awkward. We need some conditional margin.
// This component drives that margin.
const AdditionalContentGate = ({
  successMessage,
  isPublished,
  children,
}: {
  successMessage?: string;
  isPublished: boolean;
  children: JSX.Element | JSX.Element[];
}) => {
  if (!(isPublished || successMessage)) {
    return null;
  }
  return <div style={{ marginTop: 24 }}>{children}</div>;
};

export default AdditionalContentGate;
